import React from "react";
import PropTypes from "prop-types";
import ConnectedClassificationSummary from "./ConnectedClassificationSummary";
import ConnectedParticipantList from "./ConnectedParticipantList";
import ConnectedPromoCodes from "./ConnectedPromoCodes";
import ConnectedRegistrationSummaryHeader from "./ConnectedRegistrationSummaryHeader";
import ConnectedTotalSummary from "./ConnectedTotalSummary";
import ConnectedUpdatePromoCodes from "./ConnectedUpdatePromoCodes";

import "./RegistrationSummary.scss";

const RegistrationSummary = ({ displayHeader = true }) => (
    <>
        <ConnectedUpdatePromoCodes />
        <div className="registration-summary">
            <div className="registration-summary__content">
                {displayHeader && <ConnectedRegistrationSummaryHeader />}
                <ConnectedClassificationSummary />
                <ConnectedParticipantList />
                <ConnectedTotalSummary />
                <ConnectedPromoCodes />
            </div>
        </div>
    </>
);

RegistrationSummary.propTypes = {
    displayHeader: PropTypes.bool.isRequired,
};

export default RegistrationSummary;
